import React, { useContext } from 'react';
import { AppContext } from '../../context/AppContext';
import { TopbarCard } from '../UI/FinancialCard';
import './topsidebar.css'
import { AmountCard } from './AmountCard';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

function TopBar() {
    // Extract values from AppContext
    const token = Cookies.get("token");
    const { total = 0, currentMoney, creditDebit } = useContext(AppContext);
    const decodedToken = jwtDecode(token);
    console.log(currentMoney);
    const hrItem = currentMoney.find(item => item.Name === "HR");
// console.log("HR Amount:", hrItem ? hrItem.Current : "Not found");

    let userid = 0;

    if (token) {
        try {
            const decodedToken = jwtDecode(token);
            userid = parseInt(decodedToken.UserID, 10) || 0; // convert to number safely
        } catch (error) {
            console.error("Invalid token:", error);
        }
    }

    // console.log("UserID:", userid);

    return (
        <div id="kt_header" className="header align-items-stretch">
            <div className="container-fluid d-flex flex-row align-items-stretch justify-content-between">
                {/* Mobile Menu Toggle */}
                <div
                    className="d-flex align-items-center d-lg-none ms-n2 me-2"
                    title="Show aside menu"
                >
                    <div
                        className="btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px"
                        id="kt_aside_mobile_toggle"
                    >
                        <span className="svg-icon svg-icon-1">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <path
                                    d="M21 7H3C2.4 7 2 6.6 2 6V4C2 3.4 2.4 3 3 3H21C21.6 3 22 3.4 22 4V6C22 6.6 21.6 7 21 7Z"
                                    fill="black"
                                />
                                <path
                                    opacity="0.3"
                                    d="M21 14H3C2.4 14 2 13.6 2 13V11C2 10.4 2.4 10 3 10H21C21.6 10 22 10.4 22 11V13C22 13.6 21.6 14 21 14ZM22 20V18C22 17.4 21.6 17 21 17H3C2.4 17 2 17.4 2 18V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20Z"
                                    fill="black"
                                />
                            </svg>
                        </span>
                    </div>
                </div>
                {/* Logo Section */}
                <div className="d-flex align-items-center flex-grow-1 flex-lg-grow-0">
                    <a href="/" className="d-lg-none">
                        <img
                            alt="Logo"
                            src="https://cqpplefitting.com/ad_cqpple/Admin/assets/LOGO/Png_UniqueIT-min.png"
                            className="h-30px"
                        />
                    </a>
                </div>
                <TopbarCard
                    name='Total Balance'
                    amount={total}
                    className={`${total <= 100000 ? 'text-danger' : 'text-primary'}`}
                />
                


            </div>
        </div>
    );
}

export default TopBar;
